module.exports = function() {
	return new Worker(__webpack_public_path__ + "ab9b15847fc45dae4465.users.wrkr.js");
};